import { f as a } from "./addOns-5IZhcbHD.js";
const o = {
  id: "Pick3",
  name: "Pick 3",
  style: {
    colorPrimary: "#01ba5c",
    fireball: a
  }
};
export {
  o as default
};
